export function validatePassword( password ) {
  // 规则1: 长度8-16位
  if ( password.length < 8 || password.length > 16 ) {
    return '密码长度必须为8至16位'
  }

  // 规则2: 包含三类及以上字符
  const charTypes = [
    { name : '小写字母', regex : /[a-z]/ },
    { name : '大写字母', regex : /[A-Z]/ },
    { name : '数字', regex : /[0-9]/ },
    { name : '特殊字符', regex : /[.,!@#\-\+=/]/ }
  ]
  const typeCount = charTypes.filter( type => type.regex.test( password ) ).length
  if ( typeCount < 3 ) {
    return `密码需包含大小写字母、数字、特殊字符(.,!@#-+=/)中的至少三类`
  }

  // 规则3: 禁止4个以上重复字符
  if ( /(.)\1{3,}/.test( password ) ) {
    return '密码中不能包含4个及以上连续重复的字符'
  }

  // 规则4: 禁止连续序列
  for ( let i = 0; i <= password.length - 3; i++ ) {
    const slice = password.substring( i, i + 3 ).toLowerCase()
    const codes = [...slice].map( c => c.charCodeAt( 0 ) )

    // 检查连续序列
    const isIncreasing = (
      codes[0] + 1 === codes[1] &&
      codes[1] + 1 === codes[2]
    )

    // 检查递减序列
    const isDecreasing = (
      codes[0] - 1 === codes[1] &&
      codes[1] - 1 === codes[2]
    )

    if ( isIncreasing || isDecreasing ) {
      const type = /\d{3}/.test( slice ) ? '数字序列' : '字母序列'
      const pattern = isIncreasing ? '递增' : '递减'
      return `密码中不能包含连续的${pattern}${type}（如${slice}）`
    }
  }

  // 规则5: 禁止键盘连续组合
  const keyboardRows = [
    'qwertyuiop', 'asdfghjkl', 'zxcvbnm',
    '1234567890', '!@#$%^&*()'
  ]

  const keyboardSequences = []
  keyboardRows.forEach( row => {
    // 横向序列（3-6字符）
    for ( let len = 3; len <= 6; len++ ) {
      for ( let i = 0; i <= row.length - len; i++ ) {
        const seq = row.substring( i, i + len )
        keyboardSequences.push( seq, [...seq].reverse().join( '' ) )
      }
    }
    // 斜向序列（对角线组合）
    ['qaz', 'wsx', 'edc', 'rfv', 'tgb', 'yhn', 'ujm', 'ik', 'ol', 'p;',
      '1qaz', '2wsx', '3edc', '4rfv', '5tgb', '6yhn', '7ujm', '8ik', '9ol', '0p;']
      .forEach( seq => keyboardSequences.push( seq, [...seq].reverse().join( '' ) ) )
  } )

  const lowerPass = password.toLowerCase()
  for ( const seq of keyboardSequences ) {
    if ( lowerPass.includes( seq ) ) {
      return `密码中不能包含键盘连续组合：${seq.toUpperCase()}`
    }
  }

  // 规则6: 禁止常见密码
  const commonPasswords = [
    'P@ssw0rd', 'Qwerty123', 'Admin!123', 'Welcome1', 'Changeme1',
    'Password1', 'Aa123456', '1qaz2wsx', 'Qaz123wsx', 'P@ssword123',
    'Temp1234', 'Summer!23', 'Winter!23', 'Autumn!23', 'Spring!23'
  ]
  if ( commonPasswords.includes( lowerPass ) ) {
    return '该密码属于常见弱密码，请更换'
  }

  // 规则7: 禁止长连续数字（防止生日/身份证）
  if ( /(\d{6,})/.test( password ) ) {
    return '密码中不能包含6位以上连续数字（避免使用生日或身份证号）'
  }
  return ''
}



// WEBPACK FOOTER //
// ./src/utils/password.js